var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignalicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H18C16.8954 3 16 3.89543 16 5V19C16 20.1046 16.8954 21 18 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z",
    fill: "#636980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9H11.5C10.3954 9 9.5 9.89543 9.5 11V19C9.5 20.1046 10.3954 21 11.5 21H12.5C13.6046 21 14.5 20.1046 14.5 19V11C14.5 9.89543 13.6046 9 12.5 9Z",
    fill: "#636980"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H5C3.89543 16 3 16.8954 3 18V19C3 20.1046 3.89543 21 5 21H6C7.10457 21 8 20.1046 8 19V18C8 16.8954 7.10457 16 6 16Z",
    fill: "#636980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalicon);
export default __webpack_public_path__ + "static/media/signalicon.792a01939a343590e234747f3dd4ac18.svg";
export { ForwardRef as ReactComponent };